<template>
  <div class="card ace_sec" aria-label="Messages">
    <div class="card-header rgt_ic">
      <span class="ic ic8-channel float-left text-center mr-2" style="cursor: default;"></span>
      <span class="label ace_sec_hd" role="heading" aria-level="1" aria-label="Messages">Messages</span>
      <b-btn class="btn_ic float-right" aria-hidden="true" aria-label="Send Message" @click="showAdviseeChannelModal">
        <span class="fa fa-plus"></span>
      </b-btn>
    </div>
    <div class="card-body">
      <div class="row">
        <div class="channel-section">
          <div class="msg_row_section">
            <div class="msg_section_inner">
              <div class="chat-message" style="margin-bottom: 2px;" v-for="message in messages">
                <div class="message-avatar-default">
                  <span class="icon-user"></span>
                </div>
                <div class="message-details">
                  <div class="message-author-name">
                    <span class="message-author">{{message.name}}</span>
                    <span class="message-time message-time float-right">{{get12HourTime(message.date)}}</span>
                  </div>
                  <div class="message">
                    <div class="message-content float-left" v-html="message.text"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import { db } from '../../../firebase'
  import { StorageFactory } from '../../../storageFactory'

  export const localStore = StorageFactory(() => localStorage)

  export default {
    name: 'advisee-channel',
    props: ['advisee'],
    data: () => {
      return {
        messages: [],
        channelId: '',
        userChannelIdMap: {},
        userId: localStore.getItem('userid')
      }
    },
    mounted () {
      let userUuid = this.advisee.userId
      this.loadPlanningStreamIdsForSelectedUsers([userUuid]).then(resp => {
        this.userChannelIdMap = resp
        this.channelId = this.userChannelIdMap[userUuid]
        this.$bindAsArray('messages', db.ref('channels/' + this.channelId + '/Messages'))
      })
    },
    methods: {
      ...mapActions([
        'updateUnread',
        'loadPlanningStreamIdsForSelectedUsers'
      ]),
      markRead () {
        let dbRef = db.ref('Unread/' + this.userId)
        dbRef.child(this.channelId).remove()
        this.updateUnread({channelId: this.channelId, unread: 0})
      },
      scrollToLastMessage () {
        setTimeout(() => {
          let scrollTo = 0
          let container = $('.msg_row_section')
          let children = $('.msg_section_inner').children()
          for (let i = 0; i < children.length; i++) {
            let elem = children.eq(i)
            scrollTo += ($(elem).innerHeight() + 15)
          }
          container.scrollTop(scrollTo)
        }, 100)
      },
      showAdviseeChannelModal () {
        this.$parent.$refs.adviseeChannelActionMenu.viewChannel()
      },
      get12HourTime (datetime) {
        let values = datetime.split(' ')
        let hrmn = values[1].split(':')
        let hr = hrmn[0]
        let mn = hrmn[1]
        let ampm = hr >= 12 ? 'pm' : 'am'
        hr = hr % 12
        hr = hr ? hr : 12
        let time = values[0] + ' ' + hr + ':' + mn + ' ' + ampm
        return time
      }
    },
    watch: {
      messages () {
        this.scrollToLastMessage()
        setTimeout(() => {
          this.markRead()
        }, 1000)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/adviseeTracker/components/AdviseeChannel.vue